import { IItemsStyleSpecifiable, IItemsStyle, ItemSeparatorKinds } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanItemsSelectable } from "../../../beans/objects";
import { MapTranslator } from "../../values";

export class ItemsStyleTranslator {
  from(bean: IObjectBeanItemsSelectable): IItemsStyle {
    return {
      separator: this.separator.from(bean["@separate-word"]),
    };
  }

  to(object: IItemsStyleSpecifiable) {
    return {
      separateWord: this.separator.to(object.itemsStyle.separator),
    };
  }

  private readonly separator = new MapTranslator<ItemSeparatorKinds, string>([
    { object: ItemSeparatorKinds.NewLine,         bean: "2" },
    { object: ItemSeparatorKinds.FullWidthToten,  bean: "3" },
    { object: ItemSeparatorKinds.FullWidthComma,  bean: "4" },
    { object: ItemSeparatorKinds.FullWidthSpace,  bean: "5" },
  ], ItemSeparatorKinds.FullWidthPoint, undefined);
}
